import { render, staticRenderFns } from "./Pintuan.vue?vue&type=template&id=1df4dbb4&scoped=true&"
import script from "./Pintuan.vue?vue&type=script&lang=js&"
export * from "./Pintuan.vue?vue&type=script&lang=js&"
import style0 from "./Pintuan.vue?vue&type=style&index=0&id=1df4dbb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df4dbb4",
  null
  
)

export default component.exports